<template web>

  <section class="news">
    <vue-element-loading
        :active="isLoading"
        spinner="spinner"
        color="#CE4169"

    />
    <div class="container">
      <p class="section-header">
        <router-link :to="{ name: 'menu', params: { owners_association_id: owners_association.id } }">

          <img src="@/assets/img/icons/chevron-left.svg" alt="volver" class="chevron-left sd-sm-block d-md-none" />
        </router-link>
        Votaciones</p>

    </div>

    <div class="news-index">
      <div class="container">

        <br>

        <div class="empty-state empty-state-news" v-if="!isLoading && votations && votations.length===0">
          <div class="wrapper">
            <h4>¡Aún no hay votaciones!</h4>
            <p>Tu administración todavía no publicó ninguna votacion sobre este consorcio.</p>
            <img src="@/assets/img/empty-states/no-hay-noticias.png" class="image-empty" alt="">
          </div>
        </div>

        <div class="news-item news-item-with-image" v-for="v in votations"
             :key="v.id">
          <router-link
               
                  :key="v.id"
                  :to="{ name: 'detalle-votacion', params: { id: v.id, owners_association_id: owners_association.id } }"
                  class="news-item news-item-with-image"
          >
            <div class="news-main">
            
              <div class="news-data">

                <h3 class="news-title">{{v.title | truncate(40)}}</h3>
                <div class="news-body body_news">{{v.excerpt}}</div>
              </div>
            </div>
            <p class="news-meta">
              <span class="news-administration-name">Finaliza en </span>
              <span class="news-date">{{ v.ends_at | moment('ll') }}</span>
            </p>
            <div>
            <div class="status-badge-votations" :class="'badge-' + getVotationStatus(v.VotationStatuses.title)">
              {{ v.VotationStatuses.title }} 
            </div>

           - {{hasVoted(v)}}</div>
          </router-link>

        </div>
      </div>

    </div>

  </section>

</template>

<script>

export default {
  name: 'votations',
  props: ['owners_association'],
  data() {
    return {
      votations: [],
      stopLoading: false,
      isLoading: false,
      page: 0,
    };
  },
  mounted() {
    this.loadVotations();
  },
  methods:
      {
        
        hasVoted(votation) {
          let result = 'No votaste';
         
            if (votation.votation_votes.length != 0) result = 'Votaste';
            else
            if (votation.votation_status_id == 1) {
              result = 'Aún no votaste';
          } else {
            result = 'No votaste';
          }
          return result;
        },
        getVotationStatus(votation_status) {

          switch (votation_status) {
            
            case 'Activa':
              return 'success';
            case 'Pendiente':
            case 'Borrador':
              return 'warning';
            case 'Finalizada':
              return 'info';
            case 'Cancelada':
              return 'error';
            case 'Pausada':
              return 'secondary';
            default:
              return 'secondary';
          }

        },
        loadVotations() {
          this.page += this.page + 1;
          this.isLoading = true;
          this.getVotations(this.owners_association.id, this.page)
              .then((data) => {
                console.log(`votations ${JSON.stringify(data)}`);

                // 1. Combina las votaciones existentes con las nuevas que llegaron
                const allVotations = this.votations.concat(data);

                // 2. Ordena el array combinado por la fecha 'starts_at' en orden descendente
                allVotations.sort((a, b) => new Date(b.starts_at) - new Date(a.starts_at));

                // 3. Asigna el array ya ordenado
                this.votations = allVotations;

                this.isLoading = false;
              })
              .catch(() => {
                this.stopLoading = true;
                this.isLoading = false;
              });
        },
      },
};

</script>
<style scoped>

.status-badge-votations
{display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
  color: white;
  margin: 4px 0;}

</style>
